import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../helpers/hooks';

const NonAuthLayout: React.FC = () => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default NonAuthLayout;
